import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { AddIcon } from "@/components/Icons";
import { formatChipValue } from "@/lib/formatting";
import type { PlayerDraft, HiddenFinalPlayer } from "@/hooks/usePlayersState";

interface HiddenPlayersPanelProps {
  hiddenFinalPlayers: HiddenFinalPlayer[];
  players: PlayerDraft[];
  restorePlayerToFinalList: (id: string) => void;
}

export function HiddenPlayersPanel({
  hiddenFinalPlayers,
  players,
  restorePlayerToFinalList,
}: HiddenPlayersPanelProps) {
  return (
    <details className="pt-1">
      <summary className="cursor-pointer font-medium">
        Removed from final chips list ({hiddenFinalPlayers.length})
      </summary>
      {hiddenFinalPlayers.length === 0 ? (
        <p className="mt-2 text-sm text-muted-foreground">No removed players.</p>
      ) : (
        <div className="mt-2 space-y-3">
          {hiddenFinalPlayers.map((hiddenPlayer) => {
            const player = players.find((p) => p.id === hiddenPlayer.id);
            if (!player) return null;

            return (
              <div
                key={`hidden-final-${hiddenPlayer.id}`}
                className="grid gap-2 grid-cols-[1.75rem_minmax(0,1fr)_4.75rem] md:grid-cols-[1.75rem_2fr_1fr] md:gap-3 items-center"
              >
                <Button
                  type="button"
                  variant="outline"
                  size="icon-sm"
                  className="rounded-full"
                  onClick={() => restorePlayerToFinalList(hiddenPlayer.id)}
                  aria-label={`Re-add ${player.name || "player"} to final chips list`}
                  title="Re-add to final chips list"
                >
                  <AddIcon />
                </Button>

                <Input value={player.name || "Unnamed player"} readOnly className="h-8 px-2 text-xs md:h-9 md:px-3 md:text-sm" />
                <Input
                  value={formatChipValue(hiddenPlayer.previousFinalChips) || "0"}
                  readOnly
                  className="h-8 px-2 text-xs md:h-9 md:px-3 md:text-sm"
                />
              </div>
            );
          })}
        </div>
      )}
    </details>
  );
}
